import React, { useState } from 'react';

// internal components
import Ratings from '../../components/starRating/index';
import Response from './Response';
import CommentReplyButton from './CommentReplyButton';
import CommentAdminButtons from './CommentAdminButtons';
import ReplyModal from './modal/Reply';

import ENUMS from '../../enums';
import { dataGenerator, enumHelper } from '../../utils';
import styles from './styles.scss';

const { CONFIRMED, REJECTED, WAITING } = ENUMS.COMMENT_STATUS.values;

const Comment = props => {
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false);

  const handleStarClick = (rate, name, parentIndex) => {
    props.handleStarClick(rate, name, parentIndex);
  };

  const getCommentCssClassNameHeader = () => {
    let cssClassName = 'card-header d-flex px-2 text-white ';

    switch (props.comment.status) {
      case WAITING:
        cssClassName += 'bg-secondary';
        break;
      case CONFIRMED:
        cssClassName += 'bg-success';
        break;
      case REJECTED:
        cssClassName += 'bg-danger';
        break;
      default:
        cssClassName += 'bg-primary';
        break;
    }

    return cssClassName;
  };

  const closeReplyModal = () => {
    setIsReplyModalOpen(false);
  };

  const openReplyModal = () => {
    setIsReplyModalOpen(true);
  };

  return (
    <div className="col-12 p-0">
      {/* user Comment */}

      <div className="col-12 p-0 d-flex justify-content-start mt-4">
        <div className="d-flex flex-column justify-content-start px-3 align-items-center">
          <img
            className="img-circle rounded-circle border userCommentsAvatar"
            src={
              props.comment.userAvatar && props.comment.userAvatar.length
                ? props.comment.userAvatar
                : require('../../assets/icons/userDefault.png')
            }
          />
          <div className={styles.userFullName} title={props.comment.userFullName}>
            {props.comment.userFullName}
          </div>
        </div>

        <div className="card col-7 px-0">
          <div className={getCommentCssClassNameHeader()}>
            <div className="col-9 p-1">
              {!props.comment.cafeName.startsWith('کافه')
                ? `کافه ${props.comment.cafeName}`
                : props.comment.cafeName}
              ، {props.comment.createdAt}
            </div>
            <div className="col-3 p-0">
              <div className="d-flex col-12 p-0 justify-content-end">
                <div>
                  <i
                    className={props.comment.isConfirmed ? 'fal fa-vote-yea mx-1' : 'fal fa-vote-nay mx-1'}
                  />
                </div>
                <div>
                  {enumHelper.convertEnumValueToTitle(ENUMS.COMMENT_STATUS.list, props.comment.status)}
                </div>
              </div>
            </div>
          </div>

          <div className={`card-body text-primary d-flex flex-wrap ${styles.commentText}`}>
            {props.comment.message}
          </div>
          <span>شماره پیگیری:
            <span className="misa">{props.comment.trackingNumber}</span>
          </span>
          {/*<p className="pr-1">شماره پیگیری: {props.comment.trackingNumber}</p>*/}
          <div className="w-100 d-flex justify-content-between align-self-center px-1">
            <p> شماره رزرو: {props.comment.reserveId}</p>
            <Ratings
              starsCount={5}
              defaultRate={props.comment.score || 2.5}
              disable={true}
              color="danger"
              size="xlarge"
              renderedParentComponentIndex={props.commentIndex}
              name="comment"
              handleStarClick={handleStarClick}
            />
          </div>

          <div className="card-footer d-flex justify-content-between p-2 hideEmptyDiv">
            <div>
              <CommentAdminButtons
              id={props.comment.id}
              status={props.comment.status}
              isCafeAllowedToRespond={props.comment.isCafeAllowedToRespond}
              changeCafeAccessStatusToResponse={props.changeCafeAccessStatusToResponse}
              refreshList={props.refreshList}
              updateCommentStatus={props.updateCommentStatus}
            />

              <CommentReplyButton
                id={props.comment.id}
                status={props.comment.status}
                canReplyByRseeUser={props.comment.canReplyByRseeUser}
                canReplyByCafeUser={props.comment.canReplyByCafeUser}
                openReplyModal={openReplyModal}
              />
            </div>
            <div className='col-2 p-2 bg-dark text-light text-center rounded'>
              {enumHelper.convertEnumValueToTitle(
                ENUMS.CAFE_TYPE.list, props.comment.cafeType)}
            </div>
          </div>
        </div>
      </div>
      {/* end of user Comment */}

      {/* Rsee or Cafe Responses to Comment */}
      {props.comment.responses.map(response => (
        <Response
          key={'cmn_response_' + response.id}
          response={response}
          displayEditModal={props.displayEditModal}
        />
      ))}

      {isReplyModalOpen && (
        <ReplyModal
          isOpen={isReplyModalOpen}
          commentId={props.comment.id}
          close={closeReplyModal}
          reply={props.replyToComment}
          scrollToComment={props.scrollToComment}
        />
      )}
    </div>
  );
};

export default Comment;
